import type { UserSubscriptionFragment } from '@lingoda/graphql';

export const isSubscriptionFFreeTrial = (
    subscription: Pick<UserSubscriptionFragment, 'paymentMethodAdded'> | null | undefined,
) => {
    return !!subscription && subscription.paymentMethodAdded !== null;
};
